import { useCallback, useEffect, useState } from 'react';
import { getUnlockRequestsCountApiCall } from '../services/api/accountLocking';

const POLL_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

export const UNLOCK_REQUESTS_UPDATED_EVENT = 'unlock-requests-updated';

/** Call after approving/rejecting to refresh the sidebar badge. */
export function notifyUnlockRequestsUpdated() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(UNLOCK_REQUESTS_UPDATED_EVENT));
  }
}

export function useUnlockRequestsCount(enabled: boolean) {
  const [count, setCount] = useState<number>(0);

  const refetch = useCallback(async () => {
    if (!enabled) return;
    try {
      const res = await getUnlockRequestsCountApiCall();
      setCount(typeof res.data === 'number' ? res.data : 0);
    } catch {
      setCount(0);
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return;
    refetch();
    const id = setInterval(refetch, POLL_INTERVAL_MS);
    return () => clearInterval(id);
  }, [enabled, refetch]);

  useEffect(() => {
    if (!enabled) return;
    const handler = () => refetch();
    window.addEventListener(UNLOCK_REQUESTS_UPDATED_EVENT, handler);
    return () => window.removeEventListener(UNLOCK_REQUESTS_UPDATED_EVENT, handler);
  }, [enabled, refetch]);

  return { count, refetch };
}
